import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import Spinner from "../../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../../component/message/Msg";
import TableViewer from "../../../component/tableViewer/TableViewer";

const ViewLeadProfiles = () => {
  const token = config.token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [leadprofiles, setLeadprofiles] = useState([]);

  //  ------For TableViewer ------
  const leadprofilesRef = useRef([]);
  leadprofilesRef.current = leadprofiles;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  const handleChangeStatus = async (e, lpid, i) => {
    //  ------For TableViewer ------
    const updatedLeadprofiles = [...leadprofiles];
    updatedLeadprofiles[i] = {
      ...updatedLeadprofiles[i],
      status: e.target.value,
    };
    setLeadprofiles(updatedLeadprofiles);

    const leadprofilesData = updatedLeadprofiles.map((leadprofile) => ({
      name:
        leadprofile.first_name_of_lead + " " + leadprofile.last_name_of_lead,
      email: leadprofile.email_1 + ", " + leadprofile.email_2,
      address:
        leadprofile.city +
        ", " +
        leadprofile.state +
        ", " +
        leadprofile.country,
      source_type: leadprofile.lead_source_type,
      status: leadprofile.status,
      type_of_lead: leadprofile.type_of_lead,
      idNumber: leadprofile.lead_profile_id,
    }));
    setRowData(leadprofilesData);
    //  ------For TableViewer ------

    try {
      await fetch(
        `${config.host_url}lead-profile/status/${lpid}?status=${e.target.value}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Lead profile status updated successfully."
            );
            if (e.target.value === "Invoice_generated") {
              console.log("refresh");
              getLeadProfile();
            }
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error updating lead profile status");
    }
  };

  //--------------------------------------------------------- get lead-profile leadprofile ---------------------------------------------------------r

  const getLeadProfile = () => {
    setLoading(true);
    fetch(`${config.host_url}lead-profile/`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          setLeadprofiles(data.data);

          //  ------For TableViewer ------
          const leadprofilesData = data.data.map((leadprofile) => ({
            name:
              leadprofile.first_name_of_lead +
              " " +
              leadprofile.last_name_of_lead,
            email: leadprofile.email_1 + ", " + leadprofile.email_2,
            address:
              leadprofile.city +
              ", " +
              leadprofile.state +
              ", " +
              leadprofile.country,
            source_type: leadprofile.lead_source_type,
            status: leadprofile.status,
            type_of_lead: leadprofile.type_of_lead,
            idNumber: leadprofile.lead_profile_id,
          }));
          setRowData(leadprofilesData);
          //  ------For TableViewer ------
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getLeadProfile();
  }, [token]);

  // ---------------------------------------------------- Delete leadprofile ---------------------------------------------------------D
  // Show a confirmation dialog
  const handleDeleteBtn = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete lead profile. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteLeadProfile(deleteId, i);
      }
    });
  };

  //If confirm then delete leadprofile
  const handleDeleteLeadProfile = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}lead-profile/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Lead profile deleted successfully."
            );

            //  ------For TableViewer ------
            const updatedleadprofilesStatus = [...leadprofilesRef.current];
            updatedleadprofilesStatus.splice(i, 1);
            setLeadprofiles(updatedleadprofilesStatus);

            const leadprofilesData = updatedleadprofilesStatus.map(
              (leadprofile) => ({
                name:
                  leadprofile.first_name_of_lead +
                  " " +
                  leadprofile.last_name_of_lead,
                email: leadprofile.email_1 + ", " + leadprofile.email_2,
                address:
                  leadprofile.city +
                  ", " +
                  leadprofile.state +
                  ", " +
                  leadprofile.country,
                source_type: leadprofile.lead_source_type,
                status: leadprofile.status,
                type_of_lead: leadprofile.type_of_lead,
                idNumber: leadprofile.lead_profile_id,
              })
            );
            setRowData(leadprofilesData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting lead profile");
    }
  };

  //----------------------------------------------- redir to lead profile detail -------------------------------------------------
  const handleShowBtn = (id) => {
    const encodedId = btoa(encodeURIComponent(id));
    navigate(`/viewleadprofile/${encodedId}`);
  };

  //----------------------------------------------- update / edit employee (redir to add lead profile)  -------------------------------------------------
  const handleEditBtn = (id) => {
    navigate(`/addleadprofile/${btoa(encodeURIComponent(id))}`);
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "name", filter: true },
    { field: "email", filter: true },
    { field: "address", filter: true },
    { field: "source_type", filter: true },
    { field: "type_of_lead", filter: true },
    { field: "type_of_lead", filter: true },
    {
      headerName: "Status",
      field: "status",
      width: 200,
      cellRenderer: (params) => (
        <>
          <p className="p-0 m-0">
            {params.data.status === "Invoice_generated"
              ? "Invoice Generated"
              : params.data.status === "Demo_completed"
              ? "Demo Completed"
              : params.data.status === "not_connected"
              ? "Not Connected"
              : "NA"}
          </p>
        </>
      ),
    },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Lead Profile" subpath={["View Lead Profiles"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Lead Profiles</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addleadprofile");
                }}
              >
                Add Lead Profile
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={handleEditBtn}
                onDelete={handleDeleteBtn}
                onView={handleShowBtn}
                onStatusChange={handleChangeStatus}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewLeadProfiles;
